//============================================================================================================
//  GLOBAL VARS
//============================================================================================================

var fancyOverlayColor = '#fff';
var fancyOverlayOpacity = 0.75;
var rating = 4.3;

//============================================================================================================
//  DOCUMENT READY
//============================================================================================================
$(document).ready(function () {

    initMyAccountFunctions();
    initCheckoutFunction();

    function initMyAccountFunctions() {
        if (typeof (InitMyAccountFunctions) == "function")
            InitMyAccountFunctions();
    };

    function initCheckoutFunction() {
        if (typeof (InitCheckoutFunctions) == "function")
            InitCheckoutFunctions();
    };

    $('*[data-numbers-allowed="true"]').keyup(function () {
        var value = this.value.replace(/[^0-9\.,]/g, '');

        if (this.value != value) {
            this.value = value;
        }
    });

    formatPrices();

    var $serviceForm = $('.x-service-form');
    var serviceForm = $serviceForm.get(0);

    var $testDriveForm = $('.x-test-drive-form');
    var testDriveForm = $testDriveForm.get(0);

    var $interestForm = $('.x-interest-form');
    var interestForm = $interestForm.get(0);


    var branchesDropdownDiv = $('.branchesDropdownDiv');
    var branchesDropdown = $('.branchesDropdown');
    var branchesPlaceholder = $("#branchesPlaceholder").val();

    var makesDropdownDiv = $('.makesDropdownDiv');
    var makesDropdown = $('.makesDropdown');
    var makesPlaceholder = $("#makesPlaceholder").val();

    var modelsDropdownDiv = $('.modelsDropdownDiv');
    var modelsDropdown = $('.modelsDropdown');
    var modelsPlaceholder = $("#modelsPlaceholder").val();

    var emptyObject = {};


    Vendd.MessageBus.publishAsync('GetMakes', new Vendd.ExternalServices.Messages.GetMakes());

    var response = null;
    Vendd.MessageBus.subscribe(Vendd.ExternalServices.Messages.GetMakesSuccess, branchesDropdown, function (envelope) {
        response = envelope.message.data;
        console.log(response);
        //response = "";
        if (response) {
            $("#apiCallSuccessful").val("success");
            $("#apiCallSuccessful").change();
            branchesDropdown.bind(response);
            $('.secondary-menu a').addClass("custom-menu");
            $('.js-interested-button').addClass("custom-menu");
            $('.js-book-test-drive').addClass("custom-menu");
            //alert("success");
        } else {
            $('.secondary-menu a').addClass("custom-menu");

            $(".branchesDropdown").attr("name", "");
            $(".makesDropdown").attr("name", "");
            $(".modelsDropdown").attr("name", "");

            $(".branchesDropdownDiv").hide();
            $(".makesDropdownDiv").hide();
            $(".modelsDropdownDiv").hide();

            $(".branchesFallback").attr("name", "area");
            $(".makesFallback").attr("name", "brand");
            $(".modelsFallback").attr("name", "model");

            $(".branchesDivFallback").show();
            $(".makesDivFallback").show();
            $(".modelsDivFallback").show();

            $("#apiCallSuccessful").val("");
            $("#apiCallSuccessful").change();

            testDriveForm.updateExternalService("false");
            interestForm.updateExternalService("false");

            //alert("response is null");
        }
    });

    Vendd.MessageBus.subscribe(Vendd.ExternalServices.Messages.GetMakesFailure, branchesDropdown, function (envelope) {

        $('.secondary-menu a').addClass("custom-menu");

        $(".branchesDropdown").attr("name", "");
        $(".makesDropdown").attr("name", "");
        $(".modelsDropdown").attr("name", "");

        $(".branchesDropdownDiv").hide();
        $(".makesDropdownDiv").hide();
        $(".modelsDropdownDiv").hide();

        $(".branchesFallback").attr("name", "area");
        $(".makesFallback").attr("name", "brand");
        $(".modelsFallback").attr("name", "model");

        $(".branchesDivFallback").show();
        $(".makesDivFallback").show();
        $(".modelsDivFallback").show();

        $("#apiCallSuccessful").val("");
        $("#apiCallSuccessful").change();

        testDriveForm.updateExternalService("false");
        interestForm.updateExternalService("false");

        //alert("failure");
    });


    function DisableMakes() {
        var parsedHtml = Vendd.Handlebars.parse('makesDropDown', emptyObject);
        var placeholder = "<option value=\"\" selected>" + makesPlaceholder + "</option>";
        parsedHtml = parsedHtml.replace("<option value=\"\"></option>", placeholder);
        //$html = $(parsedHtml);
        var recreateSelect = "<select class=\"makesDropdown\" name=\"brand\" id=\"makesDropdown\" disabled>";
        recreateSelect += parsedHtml;
        recreateSelect += "</select>";
        makesDropdownDiv.html(recreateSelect);
        $('.makesDropdown').sSelect();
        $('.makesDropdownDiv .selectedTxt').html(makesPlaceholder);
        $('.makesDropdownDiv').click(function () {
            $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: inline !important");
        });
        $('.modelsDropdownDiv').click(function () {
            $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: inline !important");
        });
    }

    function DisableModels() {
        var parsedHtml = Vendd.Handlebars.parse('modelsDropDown', emptyObject);
        var placeholder = "<option value=\"\">" + modelsPlaceholder + "</option>";
        parsedHtml = parsedHtml.replace("<option value=\"\"></option>", placeholder);
        //$html = $(parsedHtml);
        var recreateSelect = "<select class=\"modelsDropdown\" name=\"model\" id=\"modelsDropdown\" disabled>";
        recreateSelect += parsedHtml;
        recreateSelect += "</select>";
        modelsDropdownDiv.html(recreateSelect);
        $('.modelsDropdown').sSelect();
        $('.modelsDropdownDiv .selectedTxt').html(modelsPlaceholder);     
    }

    function EnableMakes(selectedBranch) {
        var model = response.Data.Branches.find(function (x) {
            return x.BranchID === selectedBranch;
        });
        if (!model)
            model = emptyObject;
        var parsedHtml = Vendd.Handlebars.parse('makesDropDown', model);
        var placeholder = "<option value=\"\">" + makesPlaceholder + "</option>";
        parsedHtml = parsedHtml.replace("<option value=\"\"></option>", placeholder);
        //$html = $(parsedHtml);
        var recreateSelect = "<select class=\"makesDropdown\" name=\"brand\" id=\"makesDropdown\">";
        recreateSelect += parsedHtml;
        recreateSelect += "</select>";
        makesDropdownDiv.html(recreateSelect);

        $('.makesDropdown').sSelect().change(function () {

            var $this = $(this);
            $this.siblings('.newListSelected').children('.selectedTxt').addClass('selected');
            var value = $this.val();
            var text = $this.find("option:selected").text();
            if (value === "")
                text = "";
            // alert('changed branch val:', $this.value);

            if ($(this).closest(".x-service-form").length > 0) {
                serviceForm.updateBrand(value);
                serviceForm.updateBrandText(text);
                serviceForm.updateModel("");
                serviceForm.updateModelText("");
            }
            else if ($(this).closest(".x-test-drive-form").length > 0) {
                testDriveForm.updateBrand(value);
                testDriveForm.updateBrandText(text);
                testDriveForm.updateModel("");
                testDriveForm.updateModelText("");
            }
            else if ($(this).closest(".x-interest-form").length > 0) {
                interestForm.updateBrand(value);
                interestForm.updateBrandText(text);
                interestForm.updateModel("");
                interestForm.updateModelText("");
            }

            if (value !== "" && value !== null && value !== undefined) 
                EnableModels(selectedBranch, value);
            else 
                DisableModels();
        });

        $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: none !important");
        $('.modelsDropdownDiv').click(function () {
            $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: none !important");
        });
    }

    function EnableModels(selectedBranch, selectedMake) {
        var model = response.Data.Branches.find(function (x) {
            return x.BranchID === selectedBranch;
        }).Makes.find(function (y) {
            return y.MakeCode === selectedMake;
        });
        if (!model)
            model = emptyObject;
        var parsedHtml = Vendd.Handlebars.parse('modelsDropDown', model);
        var placeholder = "<option value=\"\">" + modelsPlaceholder + "</option>";
        parsedHtml = parsedHtml.replace("<option value=\"\"></option>", placeholder);
        $html = $(parsedHtml);
        var recreateSelect = "<select class=\"modelsDropdown\" name=\"model\" id=\"modelsDropdown\">";
        recreateSelect += parsedHtml;
        recreateSelect += "</select>";
        modelsDropdownDiv.html(recreateSelect);

        $('.modelsDropdown').sSelect().change(function () {
            var $this = $(this);
            $this.siblings('.newListSelected').children('.selectedTxt').addClass('selected');
            var value = $this.val();
            var text = $this.find("option:selected").text();
            if (value === "")
                text = "";

            if ($(this).closest(".x-service-form").length > 0) {
                serviceForm.updateModel(value);
                serviceForm.updateModelText(text);
            }
            else if ($(this).closest(".x-test-drive-form").length > 0) {
                testDriveForm.updateModel(value);
                testDriveForm.updateModelText(text);
            }
            else if ($(this).closest(".x-interest-form").length > 0) {
                interestForm.updateModel(value);
                interestForm.updateModelText(text);
            }
        });
    }

    branchesDropdown.bind = function bind(response) {
        /*compiled partial with literals*/
        var parsedHtml = Vendd.Handlebars.parse('branchesDropDown', response);
        var placeholder = "<option value=\"\">" + branchesPlaceholder + "</option>";
        parsedHtml = parsedHtml.replace("<option value=\"\"></option>", placeholder);
        //$html = $(parsedHtml);
        //branchesDropdown.html($html);

        var recreateSelect = "<select class=\"branchesDropdown\" name=\"area\" id=\"branchesDropdown\">";
        recreateSelect += parsedHtml;
        recreateSelect += "</select>";
        branchesDropdownDiv.html(recreateSelect);

        DisableMakes();
        DisableModels();

        $('.branchesDropdown').sSelect().change(function () {

            var $this = $(this);
            $this.siblings('.newListSelected').children('.selectedTxt').addClass('selected');
            var value = $this.val();
            var text = $this.find("option:selected").text();
            if (value === "")
                text = "";
            // alert('changed branch val:', $this.value);

            if ($(this).closest(".x-service-form").length > 0) {
                serviceForm.updateBranch(value);
                serviceForm.updateBranchText(text);
                serviceForm.updateBrand("");
                serviceForm.updateBrandText("");
                serviceForm.updateModel("");
                serviceForm.updateModelText("");

                DisableModels();
            }
            else if ($(this).closest(".x-test-drive-form").length > 0) { 
                testDriveForm.updateBranch(value);
                testDriveForm.updateBranchText(text);
                testDriveForm.updateBrand("");
                testDriveForm.updateBrandText("");
                testDriveForm.updateModel("");
                testDriveForm.updateModelText("");

                DisableModels();
            }
            else if ($(this).closest(".x-interest-form").length > 0) {
                interestForm.updateBranch(value);
                interestForm.updateBranchText(text);
                interestForm.updateBrand("");
                interestForm.updateBrandText("");
                interestForm.updateModel("");
                interestForm.updateModelText("");

                DisableModels();
            }

            if (value !== "" && value !== null && value !== undefined)
                EnableMakes(value);
            else
                DisableMakes();
        });     

        //alert("done");
    };


    function PreSelectMakeAndModel(makeCode, modelCode) {
        /*compiled partial with literals*/
        var parsedHtml = Vendd.Handlebars.parse('branchesDropDown', response);
        var placeholder = "<option value=\"\">" + branchesPlaceholder + "</option>";
        parsedHtml = parsedHtml.replace("<option value=\"\"></option>", placeholder);
        //$html = $(parsedHtml);
        //branchesDropdown.html($html);

        var recreateSelect = "<select class=\"branchesDropdown\" name=\"area\" id=\"branchesDropdown\">";
        recreateSelect += parsedHtml;
        recreateSelect += "</select>";
        branchesDropdownDiv.html(recreateSelect);

        $('.branchesDropdown').sSelect().change(function () {

            var $this = $(this);
            $this.siblings('.newListSelected').children('.selectedTxt').addClass('selected');
            var value = $this.val();
            var text = $this.find("option:selected").text();
            if (value === "")
                text = "";
            // alert('changed branch val:', $this.value);

            if ($(this).closest(".x-service-form").length > 0) {
                serviceForm.updateBranch(value);
                serviceForm.updateBranchText(text);
            }
            else if ($(this).closest(".x-test-drive-form").length > 0) {
                testDriveForm.updateBranch(value);
                testDriveForm.updateBranchText(text);
            }
            else if ($(this).closest(".x-interest-form").length > 0) {
                interestForm.updateBranch(value);
                interestForm.updateBranchText(text);
            }

        });     


        var make = response.Data.Branches.find(function (x) {
            return x.Makes.find(function (y) {
                return y.MakeCode === makeCode;
            });
        }).Makes.find(function (x) {
            return x.Families.find(function (y) {
                return y.FamilyCode === modelCode;
            });
        });
        var family = make.Families.find(function (y) {
            return y.FamilyCode === modelCode;
        });

        parsedHtml = Vendd.Handlebars.parse('makesDropDown', emptyObject);
        placeholder = "<option value=\"" + make.MakeCode + "\" selected>" + make.MakeDescription + "</option>";
        parsedHtml = parsedHtml.replace("<option value=\"\"></option>", placeholder);
        //$html = $(parsedHtml);
        recreateSelect = "<select class=\"makesDropdown\" name=\"brand\" id=\"makesDropdown\" disabled>";
        recreateSelect += parsedHtml;
        recreateSelect += "</select>";
        makesDropdownDiv.html(recreateSelect);
        $('.makesDropdown').sSelect();
        $('.makesDropdownDiv .selectedTxt').html(make.MakeDescription);


        parsedHtml = Vendd.Handlebars.parse('modelsDropDown', emptyObject);
        placeholder = "<option value=\"" + family.FamilyCode + "\" selected>" + family.FamilyDescription + "</option>";
        parsedHtml = parsedHtml.replace("<option value=\"\"></option>", placeholder);
        //$html = $(parsedHtml);
        recreateSelect = "<select class=\"modelsDropDown\" name=\"model\" id=\"modelsDropDown\" disabled>";
        recreateSelect += parsedHtml;
        recreateSelect += "</select>";
        modelsDropdownDiv.html(recreateSelect);
        $('.modelsDropDown').sSelect();
        $('.modelsDropdownDiv .selectedTxt').html(family.FamilyDescription);

        $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: none !important");
        $('.makesDropdownDiv').click(function () {
            $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: none !important");
        });
        $('.modelsDropdownDiv').click(function () {
            $('.branchesDropdownDiv').closest('.form-row').children('.error-wrapper').children('.please-select-area').attr("style", "display: none !important");
        });

        serviceForm.updateBrandText(make.MakeDescription);
        serviceForm.updateModelText(family.FamilyDescription);

        testDriveForm.updateBrandText(make.MakeDescription);
        testDriveForm.updateModelText(family.FamilyDescription);

        interestForm.updateBrandText(make.MakeDescription);
        interestForm.updateModelText(family.FamilyDescription);
    }

    $("#preSelectedMakeModel").on('change', function (e, brand, model) {
        var value = $(this).val();

        if (value === "true") {
            PreSelectMakeAndModel(brand, model);
        }
        else {
            branchesDropdown.bind(response);
        }
    });
    
    fullScreenPopup();
});

/**
 * detect IE 9
 * returns version of IE or false, if browser is not Internet Explorer 9
 */
function detectIE() {
    var ua = window.navigator.userAgent;

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    // other browser
    return false;
}

//============================================================================================================
//  DOCUMENT READY END
//============================================================================================================
function numbersOnly(event) {
	// left arrow, right arrow, tab
	if (event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) {
	}
	else if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35) { // delete, backspace, home, end
	}
	else {
		if (event.keyCode < 95) {
			if (event.keyCode < 48 || event.keyCode > 57) // numbers
				event.preventDefault();
		}
		else {
			if (event.keyCode < 96 || event.keyCode > 105) // keypad
				event.preventDefault();
		}
	}
}

function preventSpecialCharacter(e) {
	var shiftPressed = e.shiftKey;
	var keyCode = e.keyCode;

	if (shiftPressed) {
		// In Order: '<', '>', '#', '&', '%', '{', '}'
		if (keyCode == 188 || keyCode == 190 || keyCode == 51 || keyCode == 55 || keyCode == 53 || keyCode == 219 || keyCode == 221)
			e.preventDefault();
	} else {
		// In Order: '/', '[', ']', '/(numPad)', '&', '%'
		if (keyCode == 191 || keyCode == 219 || keyCode == 221 || keyCode == 111)
			e.preventDefault();
	}
};

function phoneGROnly(event) {
	numbersOnly(event);
	if ($(event.currentTarget).val().length > 9)
		// delete, backspace, home, end, left arrow, right arrow, tab
		if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) { }
		else { event.preventDefault(); }
}

function stickyContainer(container, cssClass) {
    //Sticky container on scroll

    //Call Example
    //stickyContainer($('.header-region'), 'sticky');

    var containerHeight = container.height();
    var scrlTop = $(window).scrollTop();
    container.before("<div class='spacer'></div>");
    var spacer = $('.spacer');

    //Initialize
    if (scrlTop >= containerHeight) {
        spacer.height(containerHeight);
        container.addClass(cssClass);
    }
    else {
        spacer.height(0);
        container.removeClass(cssClass);
    }

    /* respond to scroll event */
    $(window).scroll(function () {
        scrlTop = $(window).scrollTop();
        if (scrlTop >= containerHeight) {
            spacer.height(containerHeight);
            container.addClass(cssClass);
        }
        else {
            spacer.height(0);
            container.removeClass(cssClass);
        }
    });
}

function scroll_to_class(element_class, removed_height) {
    var scroll_to = $(element_class).offset().top - removed_height;
    if ($(window).scrollTop() != scroll_to) {
        $('html, body').stop().animate({
            scrollTop: scroll_to
        }, 0);
    }
}

function saveProductToStorage(id, skuId, path, qty, defaultcolorId, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo) {
    product = {
        id: id,
        skuId: skuId,
        path: path,
        qty: qty,
        defaultcolorId: defaultcolorId,
        extraAttributes: extraAttributes,
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems,
        itemInfo: itemInfo
    };
    Lockr.set('product', product);
}

function notPartOfComboProductsToStorage(id, skuId, path, qty, defaultcolorId, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo) {
    var notPartsOfCombo = Lockr.get('notPartsOfCombo');
    if (notPartsOfCombo === undefined || notPartsOfCombo === null) {
        notPartsOfCombo = [];
    }
    notPartsOfCombo.push({
        id: id,
        skuId: skuId,
        path: path,
        qty: qty,
        defaultcolorId: defaultcolorId,
        extraAttributes: extraAttributes,
        bundleItems: bundleItems,
        recipeItems: recipeItems,
        comboItems: comboItems,
        itemInfo: itemInfo
    });
    Lockr.set('notPartsOfCombo', notPartsOfCombo);
}

function hideOnScrollDown(container, cssClass) {
    // Hide container on on scroll down

    //Call Example
    //hideOnScrollDown($('.header-region'), 'hidden');

    var containerHeight = container.height();

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;

    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            var st = $(this).scrollTop();
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > containerHeight) {
                // Scroll Down
                container.addClass(cssClass);
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    container.removeClass(cssClass);
                }
            }

            lastScrollTop = st;
            didScroll = false;
        }
    }, 250);

}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function isTouch() {
    return ($('.touch').length > 0);
}

function importEmailForRegistration() {

    var email = sessionStorage.getItem('registrationEmail');

    if ($('.x-registration-form').length > 0 && email) {
        $('.x-registration-form input[name="email"]').val(email);
    }

    if ($('.x-registration-b2b-form').length > 0 && email) {
        $('.x-registration-b2b-form input[name="email"]').val(email);
    }

}

function initTooltips() {
    var $wrapper = $('.form-row .tooltip-info-wrapper');

    if ($wrapper.length < 1)
        return;

    $('.info-btn', $wrapper).click(function () {
        var tooltipBox = $(this).siblings('.info-tooltip');
        $('.info-tooltip', $wrapper).not(tooltipBox).hide();
        tooltipBox.toggle();
    });

    $(document).on('click', function (e) {
        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $('.info-tooltip', $wrapper).hide();
        }
    });
}

// in case of pages that need to load inside an iframe
// and call parent vendd js to execute some actions
// make sure that parent vendd iframe is accessible
function getParentOrSelfVendd() {
    try {

        if (typeof parent.Vendd != "undefined")
            return parent.Vendd;
    }
    catch (error) { }

    return Vendd;
}

function isElementInViewport(el) {

    if (el.length <= 0)
        return false;
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
}

function fullScreenPopup() {
    var $fancyButton = $('.full-screen-popup, a[href^="#bookTestDrive"], a[href^="#bookService"], a[href^="#requestQuote"], a[href^="#contactForm"]');

    if (!$fancyButton.length > 0)
        return;

    $fancyButton.each(function (i, el) {
        //if href has query attributes, save them to separate data attributes and rewrite href so fancybox doesn't return an error
        if ($(el).attr('href') !== undefined &&
            $(el).attr('href').split('?')[1] !== undefined &&
            $(el).attr('href').split('?')[1].split('&')[1] !== undefined) {
            $(el).attr('data-offername',decodeURI($(el).attr('href').split('?')[1].split('&')[0].split('=')[1]));
            $(el).attr('data-code',decodeURI($(el).attr('href').split('?')[1].split('&')[1].split('=')[1]));
            $(el).attr('href',$(el).attr('href').split('?')[0]);
        }else if($(el).attr('href') !== undefined ){
            $(el).attr('href',$(el).attr('href').split('?')[0]);
        }
    });
    $fancyButton.fancybox({
        nextEffect: 'fade',
        prevEffect: 'fade',
        nextSpeed: 300,
        prevSpeed: 300,
        loop  : true,
        btnTpl: {
            smallBtn: '<a title="Close" data-fancybox-close class="fancybox-button fancybox-close-small fancybox-close icon-exit2 stylish-fancy-close" href="javascript:;"></a>',
            arrowLeft: '<a data-fancybox-prev class="fancybox-button fancybox-button--arrow_left icon-arrow-light-left" title="{{PREV}}" href="javascript:;"></a>',
            arrowRight: '<a data-fancybox-next class="fancybox-button fancybox-button--arrow_right icon-arrow-light-right" title="{{NEXT}}" href="javascript:;"></a>'
        },
        touch: false,
        infobar: false,
        baseClass: "full-height",
        beforeLoad: function () {
            offername = this.opts.$orig[0].dataset.offername;
            code = this.opts.$orig[0].dataset.code;
            $form = $(''+this.opts.$orig.attr('href')+' div:first');
            if (offername !== undefined && code !== undefined ) {
                form = $form.get(0);
                form.reset();
                form.setOfferName(offername,code);
            }
        },
        afterLoad: function () {
        },
        afterClose: function () {
            //Reset the form
            $form = $(''+this.opts.$orig.attr('href')+'');
            form = $form.get(0);
            if (typeof form.reset === "function") {

                form.reset();
            }
        }
    });
}

function slickAriaFix(container, element) {

    if (container.length < 1 && element.length < 1)
        return;

    $(element, container).each(function () {
        var $slide = $(this).parent();
        if ($slide.attr('aria-describedby') != undefined) {
            $(this).attr('id', $slide.attr('aria-describedby'));
        }
    });
};